export default __webpack_public_path__ + "static/media/off.07b66a83.svg";